export enum StorageKeys {
  ShowPastClassEvents = "show-past-class-events",
  ShowPastEvents = "show-past-events",
}
